import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { fontFamily } from 'stylesheet';
import { letterSpacing } from 'stylesheetB2b';

export const RootContainer = styled.div<{ colors: ColormapInterface }>`
  font-family: ${fontFamily.main};
  letter-spacing: ${letterSpacing.normal};
  height: 100vh;
  background-color: ${({ colors }) => colors.appBackground};
  user-select: none;
  -webkit-touch-callout: none;
  overflow: auto;
`;
RootContainer.displayName = 'RootContainer';
